import { t } from "i18next";
import { useContext } from "react";
import { ListGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import { UserContext } from "../../App";

interface MainMenuItemsProps {
    close: CallableFunction;
}

export function MainMenuItems(props: MainMenuItemsProps) {
    const { userProfile } = useContext(UserContext);

    const handleClose = (event: any) => {
        props.close();
    }

    return (
        <div className="menu-items-container">
            { userProfile.role.filter((r: any) => r.id == 'badminton_administrator').length > 0 &&
                <div className="menu-block">
                    <ListGroup>
                        <ListGroup.Item>
                            <Link to="/admin/users" onClick={ handleClose }>
                                { t("users")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/categories" onClick={ handleClose }>
                                { t("categories")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/modality" onClick={ handleClose }>
                                { t("modalities")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/seasons" onClick={ handleClose }>
                                { t("seasons")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/clubs" onClick={ handleClose }>
                                { t("clubs")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/teams" onClick={ handleClose }>
                                { t("teams")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/athletes" onClick={ handleClose }>
                                { t("athletes")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/staff" onClick={ handleClose }>
                                { t("Coaches")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/competitions" onClick={ handleClose }>
                                { t("competitions")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/events" onClick={ handleClose }>
                                { t("Events")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/videos" onClick={ handleClose }>
                                { t("videos")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/programs" onClick={ handleClose }>
                                { t("Programs")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/settings" onClick={ handleClose }>
                                { t("Settings")}
                            </Link>
                        </ListGroup.Item>
                    </ListGroup>
                </div>
            }
            { userProfile.role.filter((r: any) => r.id == 'badminton_manager').length > 0 &&
                <div className="menu-block">
                    <ListGroup>
                        <ListGroup.Item>
                            <Link to="/" onClick={ handleClose }>
                                { t("my_space")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/manager/athletes" onClick={ handleClose }>
                                { t("athletes")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/manager/staff" onClick={ handleClose }>
                                { t("Coaches")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/manager/teams" onClick={ handleClose }>
                                { t("teams")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/manager/videos" onClick={ handleClose }>
                                { t("videos")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/programs" onClick={ handleClose }>
                                { t("Programs")}
                            </Link>
                        </ListGroup.Item>
                        {/*<ListGroup.Item>
                            <Link to="/reports" onClick={ handleClose }>
                                { t("reports")}
                            </Link>
                        </ListGroup.Item>*/}
                    </ListGroup>
                </div>
            }
            { userProfile.role.filter((r: any) => r.id == 'badminton_coach').length > 0 &&
                <div className="menu-block">
                    <ListGroup>
                        <ListGroup.Item>
                            <Link to="/" onClick={ handleClose }>
                                { t("my_space")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/athletes" onClick={ handleClose }>
                                { t("athletes")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/training-session-tpls" onClick={ handleClose }>
                                { t("training_templates")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/planning" onClick={ handleClose }>
                                { t("Planning")}
                            </Link>
                        </ListGroup.Item>
                        {/*<ListGroup.Item>
                            <Link to="/coach/training-sessions" onClick={ handleClose }>
                                { t("training_sessions")}
                            </Link>
                        </ListGroup.Item>*/}
                        <ListGroup.Item>
                            <Link to="/coach/videos" onClick={ handleClose }>
                                { t("videos")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/programs" onClick={ handleClose }>
                                { t("Programs")}
                            </Link>
                        </ListGroup.Item>
                        {/*<ListGroup.Item>
                            <Link to="/reports" onClick={ handleClose }>
                                { t("reports")}
                            </Link>
                        </ListGroup.Item>*/}
                    </ListGroup>
                </div>
            }
            { userProfile.role.filter((r: any) => r.id == 'badminton_athlete').length > 0 &&
                <div className="menu-block">
                    <ListGroup>
                        <ListGroup.Item>
                            <Link to="/" onClick={ handleClose }>
                                { t("my_space")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/training-sessions" onClick={ handleClose }>
                                { t("training_sessions")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/athlete/videos" onClick={ handleClose }>
                                { t("videos")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/programs" onClick={ handleClose }>
                                { t("Programs")}
                            </Link>
                        </ListGroup.Item>
                    </ListGroup>
                </div>
            }
        </div>
    );
}
